import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import { Email, Phone, LocationOn } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ContactSection = () => {
    return (
        <Paper elevation={4} sx={{
            p: 4,
            borderRadius: 4,
            background: 'linear-gradient(135deg, #43a047, #66bb6a)',
            color: 'white',
            textAlign: 'center'
        }}>
            <Typography variant="h4" fontWeight={700} gutterBottom>
                📞 Need Help or Have Questions?
            </Typography>
            <Typography variant="h6" paragraph sx={{ opacity: 0.9 }}>
                We're here to help! Contact us anytime for support, feedback, or suggestions.
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Email />
                    <Typography>support@sortifi.org</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Phone />
                    <Typography>+880 1822-679672</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LocationOn />
                    <Typography>IUBAT, Dhaka</Typography>
                </Box>
            </Box>
            <Button
                component={Link}
                to="/contact"
                variant="contained"
                sx={{
                    background: 'linear-gradient(135deg, #ffc400, #ffea00)',
                    color: '#1b5e20',
                    fontWeight: 700,
                    px: 4,
                    py: 1.5
                }}
            >
                Get In Touch
            </Button>
        </Paper>
    );
};

export default ContactSection;
